const partnerUserRolesOptions: { [key: string]: string } = {
  Admin: 'Admin',
  Support: 'Support',
};

export default partnerUserRolesOptions;
